import React  from 'react';
import Navbar from './component/Navbar/Navbar';
import "./App.css";
import {BrowserRouter as Router, Switch, Route} from "react-router-dom";
import Home from './component/pages/Home';
import Products from "./component/pages/Products/Products";
import Services from "./component/pages/Services/Services";
import SignUp from './component/pages/SignUp/SignUp';


function App() {
  return (
    <>
      <Router>
        <Navbar/>
          <Switch>
            <Route path="/" exact  component={Home}/>
            <Route path="/products" component={Products}/>
            <Route path="/services" component={Services}/>
            <Route path="/sign-up" component={SignUp}/>
          </Switch>
      </Router>
    </>
  )
}

export default App;